import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import type { ConfirmModalButtonsWrapperStyledOptions } from './ConfirmModal.types';

export const StyledConfirmModalButtonsWrapper = styled(
  'div',
)<ConfirmModalButtonsWrapperStyledOptions>(
  {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: '12px',
  },
  ...getAllStyledProps,
);
